module.exports = __webpack_public_path__ + "javascript.a8323e.svg";